import { Query } from '../../../../../hooks/queries'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import {
  getVrOpenClosedVulns,
  VrOpenClosedVulnsArgs,
  VrOpenClosedVulnsResponse
} from './queries/vr-open-closed-vulns'

export const useOpenClosedVulns = ({
  organizationUuid,
  facets,
  since,
  until,
  resolution
}: VrOpenClosedVulnsArgs) => {
  const { isLoading, error, data } = useContrastQuery<
    VrOpenClosedVulnsArgs,
    VrOpenClosedVulnsResponse
  >(
    [
      Query.VR_OPEN_CLOSED_VULNS,
      organizationUuid,
      facets,
      since,
      until,
      resolution
    ],
    getVrOpenClosedVulns,
    {
      organizationUuid,
      facets,
      since,
      until,
      resolution
    }
  )

  return {
    isLoading,
    error,
    data
  }
}
